import { createAction, props } from '@ngrx/store';

export const refreshDashboard = createAction('[System] Refresh dashboard');
